<p i18n class="header-text">Для данной толщины доступно несколько видов облицовки</p>
<mat-action-list>
  <button mat-list-item *ngFor="let item of data" (click)="selectButt(item)">
    {{ item.name }}
    <span *ngIf="item.article">(<span i18n>Артикул</span>{{ item.article }})</span>
  </button>
</mat-action-list>
